// Check 모듈 라우트 — AppShell children 으로 주입되어 Content(router-view)에 렌더된다.
export default [
  // 대시보드 (Remote 와 동일 카드 UI, 4개 카드)
  {
    path: "/check/dashboard",
    name: "CheckDashboard",
    component: () => import("./views/CheckDashboard.vue"),
    meta: { title: "Dashboard", perm: "CHECK_WEB" },
  },
  // 기본 진입 (원본 /check/index → CheckPositionAdd)
  {
    path: "/check/index",
    name: "CheckIndex",
    component: () => import("./views/CheckPositionAdd.vue"),
    meta: { title: "점검 위치 등록", perm: "CHECK_WEB" },
  },
  {
    path: "/check/positionAdd",
    name: "CheckPositionAdd",
    component: () => import("./views/CheckPositionAdd.vue"),
    meta: { title: "점검 위치 등록", perm: "CHECK_WEB" },
  },
  {
    path: "/check/positionSelect",
    name: "CheckPositionSelect",
    component: () => import("./views/CheckPositionSelect.vue"),
    meta: { title: "점검 위치 조회", perm: "CHECK_WEB" },
  },
  {
    path: "/check/pointAdd",
    name: "CheckPointAdd",
    component: () => import("./views/CheckPointAdd.vue"),
    meta: { title: "점검 항목 등록", perm: "CHECK_WEB" },
  },
  {
    path: "/check/pointSelect",
    name: "CheckPointSelect",
    component: () => import("./views/CheckPointSelect.vue"),
    meta: { title: "점검 항목 조회", perm: "CHECK_WEB" },
  },
  {
    path: "/check/checkResult",
    name: "CheckResult",
    component: () => import("./views/CheckResult.vue"),
    meta: { title: "점검 결과", perm: "CHECK_WEB" },
  },
  {
    path: "/check/checkResultReport",
    name: "CheckResultReport",
    component: () => import("./views/CheckResultReport.vue"),
    meta: { title: "점검 보고서", perm: "CHECK_WEB" },
  },
];
